import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface NavigationState {
  path: string | null;
}

const initialState: NavigationState = {
  path: null,
};

const navigationSlice = createSlice({
  name: 'navigation',
  initialState,
  reducers: {
    navigateTo: (state, action: PayloadAction<string | null>) => {
      state.path = action.payload;
    },
  },
});

export const { navigateTo } = navigationSlice.actions;
export default navigationSlice.reducer;
